import api from '../config/axiosConfig';
import {assertApiSuccess,normalizeDriverOrder} from '../utils/apiResponseUtils';

export function normalizeTrip(trip){
 const payment=trip.payment||trip.paymentAllocation;
 return normalizeDriverOrder(payment?.allocationStatus==='KNOWN'?{...trip,parcelWeight:trip.parcelWeight??trip.parcelWeightKg,estimatedCost:trip.estimatedCost??payment.farePaise/100,finalFare:payment.farePaise,paymentStatus:payment.paymentStatus,cashDue:payment.cashRemainingPaise,cashPaid:payment.cashVerifiedPaise,walletPaid:payment.walletPaidPaise,onlinePaid:payment.onlinePaidPaise,cashAcknowledged:trip.cashAcknowledgments?.some(item=>item.status==='ACKNOWLEDGED')}:trip);
}
export async function readTripHistory(page){
 const response=await api.get('/driver/trips/history',{params:{page,size:10}});assertApiSuccess(response);
 const result=response.data?.data;
 if(!Array.isArray(result?.items)||typeof result.hasMore!=='boolean')throw new Error('Could not confirm trip history. Please refresh.');
 return {...result,items:result.items.map(normalizeTrip)};
}
export async function readTrip(id){
 const response=await api.get('/driver/trips/'+encodeURIComponent(id));assertApiSuccess(response);
 const trip=response.data?.data;
 if(!trip||String(trip.id)!==String(id))throw new Error('Could not confirm this trip. Please refresh.');
 return normalizeTrip(trip);
}
